import React from "react";
import EditPassword from "../../../components/EditPassword";
import { RootState, useSelector } from "../../../redux/store";
import { updatePassword } from "../../../services/memberService";
import QuestionUpdateHeader from "./QuestionUpdateHeader";
import { useHistory } from 'react-router-dom';

const UpdatePassword = () => {
    const member = useSelector((state: RootState) => state.member);
    const history = useHistory();

    const onSave = async (value: string) => {
        await updatePassword(member.memberCode, value);
        history.goBack();
    };

    return (<>
        <>
            <QuestionUpdateHeader />
            <EditPassword
                isEditMode={true}
                buttonText={"שמירה"}
                subtitle={""}
                title={"שינוי סיסמה"}
                value={undefined} onSave={onSave} />
        </>
    </>)
}

export default UpdatePassword;